import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"
import qs from "qs"

import {PerksMetricsByTenant} from "@irati/types"

import {StyledCard, StyledHr} from "../../styled"
import PerksSavingsBlock from "../../../../components/Reporting/Perks/PerksSavingsBlock"
import PerksActivityChart from "../../../../components/Reporting/Perks/PerksActivityChart"

interface Props {
  perksAndPerksGoMetrics: PerksMetricsByTenant | any
}

class PerksActivityAndSavings extends PureComponent<Props> {
  componentDidMount() {
    const query = qs.parse(window.location.search.replace("?", ""))
    if (query?.report) {
      document.getElementById(query.report).scrollIntoView()
    }
  }

  render() {
    const {perksAndPerksGoMetrics} = this.props

    return (
      <Row>
        <Col xs={12}>
          <StyledHr />
          <StyledCard id="perksActivityChart">
            <PerksActivityChart perksAndPerksGoMetrics={perksAndPerksGoMetrics} />
          </StyledCard>
          <PerksSavingsBlock perksAndPerksGoMetrics={perksAndPerksGoMetrics} />
        </Col>
      </Row>
    )
  }
}

export default PerksActivityAndSavings
